import type { GraphQLAuditItem } from '@internal-audit/domain/graphql-types';
import { Text } from '@soteria/design-system-ve';

import * as styles from '../AuditDecisionPanel.css';
import * as spacingStyles from '../spacing.css';

import { PolicyAssessmentRow } from './PolicyAssessmentRow';

interface PolicyAssessment {
  policyId: string;
  policyName: string;
  isCorrect: boolean | null;
  comments?: string;
}

interface TriggeredPoliciesSectionProps {
  selectedItem: GraphQLAuditItem;
  triggeredPolicyAssessments: PolicyAssessment[];
  isSessionCompleted: boolean;
  onTriggeredPolicyAssessmentChange: (assessment: PolicyAssessment) => void;
}

export function TriggeredPoliciesSection({
  selectedItem,
  triggeredPolicyAssessments,
  isSessionCompleted,
  onTriggeredPolicyAssessmentChange,
}: TriggeredPoliciesSectionProps) {
  const triggeredPolicies = selectedItem?.contentSnapshot?.triggeredPolicies || [];

  if (triggeredPolicies.length === 0) {
    return null;
  }

  return (
    <div className={spacingStyles.flexColumn}>
      <Text className={styles.subsectionTitle}>Triggered Policies ({triggeredPolicies.length})</Text>
      <div className={spacingStyles.assessmentGroup}>
        {triggeredPolicies.map(policy => {
          const assessment = triggeredPolicyAssessments.find(a => a.policyId === policy.id);

          return (
            <PolicyAssessmentRow
              key={policy.id}
              assessment={assessment}
              disabled={isSessionCompleted}
              policy={policy}
              onAssessmentChange={onTriggeredPolicyAssessmentChange}
            />
          );
        })}
      </div>
    </div>
  );
}
